import * as R from 'ramda'
import * as React from 'react'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'

import { CasinoRow } from '../casino-row'
import { LiveCasinoRow } from '../live-casino-row'
import { LobbyBanner } from '../lobby-banner'
import { PromoText } from '../../components/common/promo-text'
import { getSections } from '../sections'

function __CasinoLobby(props) {
  const SECTIONS = R.filter(item => R.not(item.directLaunch), getSections())

  return (
    <React.Fragment>
      {!R.isEmpty(props.promotions) && (
        <LobbyBanner promotions={props.promotions} />
      )}
      <Common.Box maxWidth="1200px" margin="auto">
        <PromoText section="casino" />
        <Common.Space paddingBottom={3}>
          <LiveCasinoRow />
        </Common.Space>
        {R.map(tag => {
          const section = R.prop(tag, SECTIONS)
          return <CasinoRow key={tag} section={section} tag={tag} />
        }, R.keys(SECTIONS))}
      </Common.Box>
    </React.Fragment>
  )
}

__CasinoLobby.propTypes = {
  promotions: PropTypes.array,
}

export const CasinoLobby = React.memo(__CasinoLobby)
